import {
  ENABLE_REQUEST_ID_HEADER,
  ENABLE_SECURITY_HEADERS,
  SECURITY_ACCEPT,
  SECURITY_X_CLIENT_APP,
  SECURITY_X_REQUESTED_WITH,
} from './env';

const createRequestId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `mi-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getSecurityHeaders = () => {
  if (!ENABLE_SECURITY_HEADERS) return {};

  const headers = {
    Accept: SECURITY_ACCEPT,
    'X-Requested-With': SECURITY_X_REQUESTED_WITH,
    'X-Client-App': SECURITY_X_CLIENT_APP,
  };

  if (ENABLE_REQUEST_ID_HEADER) {
    headers['X-Request-ID'] = createRequestId();
  }

  return headers;
};
